import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = {
  key: 0,
  id: "video-player",
  style: {"width":"100%","max-height":"500px"},
  controls: ""
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_10 = { style: {"white-space":"pre-wrap"} }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("small", null, "HKT", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", null, "HKT", -1)
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 0,
  class: "ion-hide-md-down ion-text-center"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "grey-text" }
const _hoisted_30 = { style: {"margin-bottom":"0"} }
const _hoisted_31 = { style: {"font-size":"26px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_cart_button = _resolveComponent("cart-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_image_slides = _resolveComponent("image-slides")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_comment_user_chip = _resolveComponent("comment-user-chip")!
  const _component_comment_content = _resolveComponent("comment-content")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_auction_bid_list = _resolveComponent("auction-bid-list")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_star_rating = _resolveComponent("star-rating")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        showCloseModal: $props.showCloseModal,
        title: $setup.loading ? '...' : $setup.getLocalizedStr($setup.product, 'title', 'titleEn'),
        useTopRightCloseBtn: true,
        showAppDownloadToolbar: false,
        parentPath: $setup.parentPath || '/products'
      }, {
        default: _withCtx(() => [
          ($setup.product.fetchedDetails)
            ? (_openBlock(), _createBlock(_component_ion_buttons, {
                key: 0,
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.shareProduct($setup.product)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.shareSocial
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  ($setup.userLoggedIn)
                    ? (_openBlock(), _createBlock(_component_cart_button, { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["showCloseModal", "title", "parentPath"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => ($setup.fetchProductDetails($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                class: "ion-text-center",
                                "size-xs": "12",
                                "size-md": "6"
                              }, {
                                default: _withCtx(() => [
                                  ($setup.product.videoLink)
                                    ? (_openBlock(), _createElementBlock("video", _hoisted_2, [
                                        _createElementVNode("source", {
                                          src: $setup.product.videoLink,
                                          type: "video/mp4"
                                        }, null, 8, _hoisted_3)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _withDirectives(_createVNode(_component_ion_skeleton_text, {
                                          animated: true,
                                          style: {"width":"100%","height":"350px"}
                                        }, null, 512), [
                                          [_vShow, !$setup.product.imgLoaded]
                                        ]),
                                        _createElementVNode("img", {
                                          class: "rounded-img",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openImageModal($setup.product.photoLink, $setup.getLocalizedStr($setup.product, 'title', 'titleEn')))),
                                          onLoad: _cache[3] || (_cache[3] = ($event: any) => ($setup.product.imgLoaded = true)),
                                          src: $setup.addResizeUrlParams($setup.product.photoLink, 600),
                                          ref: el => { if (el && el.complete) $setup.product.imgLoaded = true }
                                        }, null, 40, _hoisted_5)
                                      ])),
                                  ($setup.product.fetchedDetails && $setup.product.photos.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createVNode(_component_image_slides, {
                                          imageLinks: $setup.product.photos.map(p => p.photoLink),
                                          minSlidesPerView: 3,
                                          size: "small",
                                          hideEyeIcon: true,
                                          defaultCaption: $setup.getLocalizedStr($setup.product, 'title', 'titleEn')
                                        }, null, 8, ["imageLinks", "defaultCaption"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!$props.showCloseModal)
                                    ? (_openBlock(), _createBlock(_component_ion_card, {
                                        key: 3,
                                        class: "info-card"
                                      }, {
                                        default: _withCtx(() => [
                                          (!$setup.product.fetchedDetails)
                                            ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                _createVNode(_component_ion_chip, {
                                                  class: "no-border",
                                                  color: "secondary",
                                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($setup.product, $setup.product.likedByUser ? 'remove' : 'add')), ["stop"]))
                                                }, {
                                                  default: _withCtx(() => [
                                                    ($setup.product.likedByUser)
                                                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                          key: 0,
                                                          color: "primary",
                                                          icon: $setup.thumbsUp
                                                        }, null, 8, ["icon"]))
                                                      : (_openBlock(), _createBlock(_component_ion_icon, {
                                                          key: 1,
                                                          icon: $setup.thumbsUpOutline
                                                        }, null, 8, ["icon"])),
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("b", null, _toDisplayString($setup.product.numOfLikes) + " like" + _toDisplayString($setup.product.numOfLikes > 1 ? 's' : ''), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_chip, {
                                                  class: "no-border",
                                                  color: "secondary"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, { icon: $setup.eye }, null, 8, ["icon"]),
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("b", null, _toDisplayString($setup.product.numOfViews) + " view" + _toDisplayString($setup.product.numOfViews > 1 ? 's' : ''), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                ($setup.product.auction)
                                                  ? (_openBlock(), _createBlock(_component_ion_chip, {
                                                      key: 0,
                                                      class: "no-border",
                                                      color: "secondary"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, { icon: $setup.person }, null, 8, ["icon"]),
                                                        _createVNode(_component_ion_label, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("b", null, _toDisplayString($setup.getNumBidders($setup.product.auction)) + " bidder" + _toDisplayString($setup.getNumBidders($setup.product.auction) > 1 ? 's' : ''), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (!$setup.isShowCommentSection())
                                                  ? (_openBlock(), _createBlock(_component_ion_chip, {
                                                      key: 1,
                                                      class: "no-border",
                                                      color: "success"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, { icon: $setup.person }, null, 8, ["icon"]),
                                                        _createVNode(_component_ion_label, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("b", null, _toDisplayString($setup.onlineViewerCount), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  ($setup.isShowCommentSection() && $setup.product.fetchedDetails && !$setup.hidePrice)
                                    ? (_openBlock(), _createBlock(_component_ion_card, {
                                        key: 4,
                                        class: "info-card",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openCommentListModal())),
                                        button: "",
                                        style: {"margin-top":"10px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, {
                                            lines: "full",
                                            button: "",
                                            detail: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "start",
                                                icon: $setup.chatbubbleEllipsesOutline
                                              }, null, 8, ["icon"]),
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h2", null, [
                                                    _createElementVNode("b", null, _toDisplayString($setup.t('liveChat')), 1)
                                                  ])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_ion_chip, {
                                                class: "no-border",
                                                color: "success"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: $setup.person }, null, 8, ["icon"]),
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("b", null, _toDisplayString($setup.onlineViewerCount), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.product.comments.slice().reverse().slice(0, 5), (comment) => {
                                            return (_openBlock(), _createBlock(_component_ion_item, {
                                              key: comment.id,
                                              lines: "none",
                                              style: {"--padding-start":"8px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_comment_user_chip, { comment: comment }, null, 8, ["comment"]),
                                                _createVNode(_component_ion_label, { style: {"margin":"5px 0"} }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_comment_content, {
                                                      comment: comment,
                                                      user: $setup.user
                                                    }, null, 8, ["comment", "user"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  ($setup.product.description)
                                    ? (_openBlock(), _createBlock(_component_ion_card, {
                                        key: 0,
                                        class: "info-card"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_ion_card_content, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", {
                                                style: {"white-space":"pre-wrap"},
                                                innerHTML: $setup.clipHtmlText($setup.getLocalizedStr($setup.product, 'description', 'descriptionEn'))
                                              }, null, 8, _hoisted_8),
                                              ($setup.isHtmlOverTextLenLimit( $setup.getLocalizedStr($setup.product, 'description', 'descriptionEn') ))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createVNode(_component_ion_button, {
                                                      fill: "clear",
                                                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showClippedText.productIntro = false))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.t('readMore')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 512), [
                                            [_vShow, $setup.showClippedText.productIntro]
                                          ]),
                                          _withDirectives(_createVNode(_component_ion_card_content, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", _hoisted_10, _toDisplayString($setup.getLocalizedStr($setup.product, 'description', 'descriptionEn')), 1)
                                            ]),
                                            _: 1
                                          }, 512), [
                                            [_vShow, !$setup.showClippedText.productIntro]
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  ($setup.product.auction)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createVNode(_component_ion_card, { class: "info-card" }, {
                                          default: _withCtx(() => [
                                            ($setup.getAuctionTimeStatus() == 'starting-soon')
                                              ? (_openBlock(), _createBlock(_component_ion_card_header, {
                                                  key: 0,
                                                  color: "tertiary",
                                                  class: "ion-text-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_card_title, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.t('auctionStartSoon')), 1)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    ($setup.locale == 'zh')
                                                      ? (_openBlock(), _createBlock(_component_ion_card_subtitle, { key: 0 }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" 拍賣將於 "),
                                                            _createElementVNode("b", null, _toDisplayString($setup.getTimeDiffText($setup.product.auction.startTime, $setup.currentTime)), 1),
                                                            _createTextVNode(" 後開始 ")
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_ion_card_title, { key: 1 }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(" Bidding will start in "),
                                                            _createElementVNode("b", null, _toDisplayString($setup.getTimeDiffText($setup.product.auction.startTime, $setup.currentTime)), 1)
                                                          ]),
                                                          _: 1
                                                        }))
                                                  ]),
                                                  _: 1
                                                }))
                                              : ($setup.getAuctionTimeStatus() == 'started')
                                                ? (_openBlock(), _createBlock(_component_ion_card_header, {
                                                    key: 1,
                                                    color: "danger",
                                                    class: "ion-text-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_card_title, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString($setup.t('inAuction')), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      ($setup.locale == 'zh')
                                                        ? (_openBlock(), _createBlock(_component_ion_card_subtitle, { key: 0 }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" 拍賣將於 "),
                                                              _createElementVNode("b", null, _toDisplayString($setup.getTimeDiffText($setup.product.auction.endTime, $setup.currentTime)), 1),
                                                              _createTextVNode(" 後結束 ")
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_ion_card_title, { key: 1 }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" Bidding closes in "),
                                                              _createElementVNode("b", null, _toDisplayString($setup.getTimeDiffText($setup.product.auction.endTime, $setup.currentTime)), 1)
                                                            ]),
                                                            _: 1
                                                          }))
                                                    ]),
                                                    _: 1
                                                  }))
                                                : ($setup.getAuctionTimeStatus() == 'ended')
                                                  ? (_openBlock(), _createBlock(_component_ion_card_header, {
                                                      key: 2,
                                                      color: "dark",
                                                      class: "ion-text-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_card_title, null, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString($setup.t('auctionClosed')), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                            _createVNode(_component_ion_list, { style: {"padding-top":"0"} }, {
                                              default: _withCtx(() => [
                                                ($setup.userLoggedIn && !$setup.userIsBidder($setup.product.auction))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                      (!$setup.user.subscribedAuctionIds.includes($setup.product.auction.id))
                                                        ? (_openBlock(), _createBlock(_component_ion_button, {
                                                            key: 0,
                                                            class: "ion-margin",
                                                            expand: "block",
                                                            fill: "outline",
                                                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.updateUserSubscribedAuction($setup.product.auction.id, 'subscribe')), ["stop"]))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_icon, {
                                                                slot: "start",
                                                                icon: $setup.notificationsOutline
                                                              }, null, 8, ["icon"]),
                                                              _createTextVNode(" " + _toDisplayString($setup.t('receiveAuctionNotifications')), 1)
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      ($setup.user.subscribedAuctionIds.includes($setup.product.auction.id))
                                                        ? (_openBlock(), _createBlock(_component_ion_button, {
                                                            key: 1,
                                                            color: "danger",
                                                            class: "ion-margin",
                                                            expand: "block",
                                                            fill: "outline",
                                                            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.updateUserSubscribedAuction($setup.product.auction.id, 'unsubscribe')), ["stop"]))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_icon, {
                                                                slot: "start",
                                                                icon: $setup.notificationsOff
                                                              }, null, 8, ["icon"]),
                                                              _createTextVNode(" " + _toDisplayString($setup.t('stopReceiveAuctionNotifications')), 1)
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createVNode(_component_ion_item, {
                                                  color: "light",
                                                  lines: "none",
                                                  button: "",
                                                  detail: "",
                                                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.openAuctionTCModal()))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("p", null, _toDisplayString($setup.t('auctionRules')), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h2", null, _toDisplayString($setup.t('auctionStartTime')), 1),
                                                        _hoisted_13
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_chip, { slot: "end" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.formatDateTime($setup.product.auction.startTime)), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h2", null, _toDisplayString($setup.t('auctionEndTime')), 1),
                                                        _hoisted_14
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_chip, { slot: "end" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.formatDateTime($setup.product.auction.endTime)), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("h2", null, _toDisplayString($setup.t('startingPrice')), 1)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_chip, { slot: "end" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("HK$" + _toDisplayString(Number($setup.product.auction.startingPrice).toLocaleString()), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                (!$setup.product.fetchedDetails)
                                                  ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 1 }))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                      _createVNode(_component_ion_item, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_label, null, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("h2", null, [
                                                                _createElementVNode("b", null, _toDisplayString($setup.t('currentBid')), 1)
                                                              ]),
                                                              ($setup.product.auction.bids.length > 0)
                                                                ? (_openBlock(), _createElementBlock("small", _hoisted_16, [
                                                                    ($setup.locale == 'zh')
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($setup.product.auction.bids.length) + "個出價", 1))
                                                                      : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.product.auction.bids.length) + " bid" + _toDisplayString($setup.product.auction.bids.length > 1 ? 's' : ''), 1))
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 1
                                                          }),
                                                          ($setup.product.auction.currentBid != null)
                                                            ? (_openBlock(), _createBlock(_component_ion_chip, {
                                                                key: 0,
                                                                color: $setup.getAuctionTimeStatus() == 'ended' ? 'sucess' : 'danger',
                                                                slot: "end"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("HK$" + _toDisplayString(Number($setup.product.auction.currentBid).toLocaleString()), 1)
                                                                ]),
                                                                _: 1
                                                              }, 8, ["color"]))
                                                            : (_openBlock(), _createBlock(_component_ion_chip, {
                                                                key: 1,
                                                                slot: "end"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("-")
                                                                ]),
                                                                _: 1
                                                              }))
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_auction_bid_list, {
                                                        bids: $setup.product.auction.bids,
                                                        userId: $setup.user.id
                                                      }, null, 8, ["bids", "userId"])
                                                    ]))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_card, { class: "info-card primary-border" }, {
                                    default: _withCtx(() => [
                                      (!$setup.hidePrice)
                                        ? (_openBlock(), _createBlock(_component_ion_card_header, {
                                            key: 0,
                                            class: "ion-text-center ion-hide-md-down"
                                          }, {
                                            default: _withCtx(() => [
                                              (!$setup.product.auction)
                                                ? (_openBlock(), _createBlock(_component_ion_card_title, {
                                                    key: 0,
                                                    color: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      ($setup.product.sellingPrice != $setup.product.price)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                            _createElementVNode("s", null, "HK$" + _toDisplayString(Number($setup.product.price).toLocaleString()), 1),
                                                            _createTextVNode(" HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1)
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_20, " HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1))
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      ($setup.product.type == 'Coral')
                                        ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                                            default: _withCtx(() => [
                                              ($setup.userLoggedIn && $setup.product.fetchedDetails)
                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 0,
                                                    lines: "full",
                                                    detail: $setup.getProductUserReview(),
                                                    button: "",
                                                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.getProductUserReview() ? $setup.openProductReviewModal() : undefined))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_avatar, { slot: "start" }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            src: $setup.user.profilePic || 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg'
                                                          }, null, 8, _hoisted_21)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("p", null, [
                                                            _createElementVNode("b", null, _toDisplayString($setup.t('yourRating')), 1)
                                                          ])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      ($setup.getProductUserReview())
                                                        ? (_openBlock(), _createBlock(_component_star_rating, {
                                                            key: 0,
                                                            rating: $setup.getProductUserReview()?.rating || 0,
                                                            "read-only": true,
                                                            glow: 3,
                                                            "star-size": 26,
                                                            "show-rating": false
                                                          }, null, 8, ["rating"]))
                                                        : (_openBlock(), _createBlock(_component_star_rating, {
                                                            key: 1,
                                                            glow: 3,
                                                            "star-size": 26,
                                                            "show-rating": false,
                                                            "onUpdate:rating": $setup.openProductReviewModal
                                                          }, null, 8, ["onUpdate:rating"]))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["detail"]))
                                                : _createCommentVNode("", true),
                                              ($setup.settings.hideProductOverallRating != 1 && $setup.product.fetchedDetails && $setup.product.reviews.length > 0)
                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 1,
                                                    lines: "full",
                                                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.openProductReviewListModal())),
                                                    detail: "",
                                                    button: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString($setup.t('productRating')), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_text, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_star_rating, {
                                                            inline: true,
                                                            rating: $setup.product.overallRating,
                                                            "max-rating": $setup.product.overallRating,
                                                            "star-size": 14,
                                                            "show-rating": false,
                                                            "read-only": true
                                                          }, null, 8, ["rating", "max-rating"]),
                                                          _createTextVNode(" (" + _toDisplayString($setup.product.reviews.length) + ") ", 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_ion_item, { lines: "full" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('coralId')), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_chip, { slot: "end" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.product.coralId), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('coralGenus')), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_chip, { slot: "end" }, {
                                                    default: _withCtx(() => [
                                                      ($setup.product.genus?.photoLink)
                                                        ? (_openBlock(), _createBlock(_component_ion_avatar, { key: 0 }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("img", {
                                                                src: $setup.addResizeUrlParams($setup.product.genus?.photoLink, 300)
                                                              }, null, 8, _hoisted_22)
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString($setup.getLocalizedStr($setup.product.genus, 'title', 'titleEn')), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 512), [
                                                [_vShow, $setup.product.genus]
                                              ]),
                                              _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('coralGrade')), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_chip, { slot: "end" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.product.coralGrade), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 512), [
                                                [_vShow, $setup.product.coralGrade]
                                              ]),
                                              _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('coralSize')), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_chip, { slot: "end" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.product.size), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 512), [
                                                [_vShow, $setup.product.size]
                                              ]),
                                              _withDirectives(_createVNode(_component_ion_item, { lines: "full" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('coralOrigin')), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_chip, { slot: "end" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.product.origin), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 512), [
                                                [_vShow, $setup.product.origin]
                                              ]),
                                              (!$props.showCloseModal)
                                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                                    key: 2,
                                                    lines: "full"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString($setup.t('coralOwner')), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (!$setup.product.fetchedDetails)
                                                        ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                                            key: 0,
                                                            slot: "end"
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_ion_chip, {
                                                            key: 1,
                                                            color: "primary",
                                                            slot: "end"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              ($setup.product.ownerProfilePic)
                                                                ? (_openBlock(), _createBlock(_component_ion_avatar, { key: 0 }, {
                                                                    default: _withCtx(() => [
                                                                      _createElementVNode("img", {
                                                                        src: $setup.product.ownerProfilePic
                                                                      }, null, 8, _hoisted_23)
                                                                    ]),
                                                                    _: 1
                                                                  }))
                                                                : _createCommentVNode("", true),
                                                              _createVNode(_component_ion_label, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString($setup.product.ownerName), 1)
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }))
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          ($setup.product.auction ? $setup.getAuctionTimeStatus() == 'started' : $setup.isProductAvailable())
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                ($setup.product.auction)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                      _createVNode(_component_ion_button, {
                                                        class: "ion-margin-bottom",
                                                        expand: "block",
                                                        size: "large",
                                                        onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.openPlaceBidModal()))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString($setup.t('placeBid')), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]))
                                                  : (!$setup.hidePrice)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                        _withDirectives(_createVNode(_component_ion_button, {
                                                          class: "ion-margin-bottom",
                                                          expand: "block",
                                                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => ($setup.addProductToCart($setup.product, $setup.selectedProductVariant)), ["stop"]))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_icon, {
                                                              slot: "start",
                                                              icon: $setup.cartOutline
                                                            }, null, 8, ["icon"]),
                                                            _createTextVNode(" " + _toDisplayString($setup.t('addToCart')), 1)
                                                          ]),
                                                          _: 1
                                                        }, 512), [
                                                          [_vShow, $setup.relatedCartItem == null]
                                                        ]),
                                                        _withDirectives(_createVNode(_component_ion_button, {
                                                          class: "ion-margin-bottom",
                                                          expand: "block",
                                                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => ($setup.removeProductFromCart($setup.product)), ["stop"])),
                                                          color: "danger"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_icon, {
                                                              slot: "start",
                                                              icon: $setup.removeCircleOutline
                                                            }, null, 8, ["icon"]),
                                                            _createTextVNode(" " + _toDisplayString($setup.t('removeFromCart')), 1)
                                                          ]),
                                                          _: 1
                                                        }, 512), [
                                                          [_vShow, $setup.relatedCartItem]
                                                        ]),
                                                        _createVNode(_component_ion_button, {
                                                          class: "ion-margin-bottom",
                                                          expand: "block",
                                                          fill: "outline",
                                                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.openCheckoutModal([{ ...$setup.product, requiredQty: 1 }])))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_icon, {
                                                              slot: "start",
                                                              icon: $setup.cardOutline
                                                            }, null, 8, ["icon"]),
                                                            _createTextVNode(" " + _toDisplayString($setup.t('buyNow')), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]))
                                            : ($setup.product.status == $setup.PRODUCT_STATUSES.hold)
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 1,
                                                  class: "ion-margin-bottom",
                                                  expand: "block",
                                                  color: "secondary",
                                                  disabled: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.t('hold')), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : ([$setup.PRODUCT_STATUSES.sold, $setup.PRODUCT_STATUSES.pendingPayment].includes($setup.product.status))
                                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                                    key: 2,
                                                    class: "ion-margin-bottom",
                                                    expand: "block",
                                                    color: "danger",
                                                    disabled: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString($setup.t('sold')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : ([$setup.PRODUCT_STATUSES.auctionClosed].includes($setup.product.status))
                                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                                      key: 3,
                                                      class: "ion-margin-bottom",
                                                      expand: "block",
                                                      color: "danger",
                                                      disabled: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.t('auctionClosed')), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                          ($setup.userLoggedIn && $setup.product.likedByUser)
                                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 4,
                                                class: "ion-margin-bottom",
                                                expand: "block",
                                                fill: "outline",
                                                onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($setup.product, 'remove')), ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    slot: "start",
                                                    icon: $setup.heart,
                                                    color: "danger"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('removeFromLikedItems')), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          ($setup.userLoggedIn && !$setup.product.likedByUser)
                                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 5,
                                                class: "ion-margin-bottom",
                                                expand: "block",
                                                fill: "outline",
                                                onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($setup.product, 'add')), ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    slot: "start",
                                                    icon: $setup.heartOutline
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('addToLikedItems')), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_ion_button, {
                                            expand: "block",
                                            fill: "outline",
                                            onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.enquireProduct($setup.product)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "start",
                                                icon: $setup.chatbubbleEllipsesOutline
                                              }, null, 8, ["icon"]),
                                              _createTextVNode(" " + _toDisplayString($setup.t('enquiry')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (!$props.showCloseModal && $setup.product.type != 'Gift' && $setup.relatedProducts.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_component_section_header, {
                          icon: $setup.cartOutline,
                          title: $setup.t('ProductPage.relatedProducts')
                        }, null, 8, ["icon", "title"]),
                        _createVNode(_component_slides, { products: $setup.relatedProducts }, null, 8, ["products"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      (!$setup.loading && !$setup.hidePrice && ($setup.product.auction ? $setup.getAuctionTimeStatus() == 'started' : $setup.isProductAvailable()))
        ? (_openBlock(), _createBlock(_component_ion_footer, {
            key: 0,
            class: "ion-hide-md-up"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--border-width":"2px 0 0 0"} }, {
                default: _withCtx(() => [
                  ($setup.product.auction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { size: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, { lines: "none" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-no-margin" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_29, [
                                          _createElementVNode("small", null, _toDisplayString($setup.t('currentBid')), 1)
                                        ]),
                                        _createElementVNode("h1", _hoisted_30, [
                                          _createElementVNode("b", null, "HK$" + _toDisplayString(Number($setup.product.auction.currentBid).toLocaleString()), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _createElementVNode("small", null, _toDisplayString($setup.getTimeDiffText($setup.product.auction.endTime, $setup.currentTime)), 1)
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              class: "ion-text-right",
                              size: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  expand: "block",
                                  size: "large",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.openPlaceBidModal()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('placeBid')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h1", _hoisted_31, [
                                        _createElementVNode("b", null, "HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-right",
                            size: "6"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_button, {
                                onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => ($setup.addProductToCart($setup.product, $setup.selectedProductVariant)), ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.cartOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('addToCart')), 1)
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, $setup.relatedCartItem == null]
                              ]),
                              _withDirectives(_createVNode(_component_ion_button, {
                                size: "small",
                                onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => ($setup.removeProductFromCart($setup.product)), ["stop"])),
                                color: "danger",
                                style: {"text-transform":"none"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.removeCircleOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('removeFromCart')), 1)
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, $setup.relatedCartItem]
                              ]),
                              _createVNode(_component_ion_button, {
                                fill: "outline",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.openCheckoutModal([{ ...$setup.product, requiredQty: 1 }])))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.cardOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('buyNow')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}